/* pg-cart-fast */
(function(){
  if (window.pgCartFast) return; window.pgCartFast = 1;

  /* ---------------- share one /cart.js ---------------- */

  var TTL = 500;                /* under the fastest poller's 700ms tick */
  var cached = null, cachedAt = 0, inflight = null, writeSeq = 0;
  var lastWrite = 0;            /* when the cart was last MUTATED -- see the
                                   staleness note on the coalescer below */
  var orig = window.fetch;
  if (typeof orig !== 'function') return;

  function urlOf(input){
    if (typeof input === 'string') return input;
    if (input && typeof input.url === 'string') return input.url;
    return '';
  }
  function methodOf(input, init){
    var m = (init && init.method) || (input && input.method) || 'GET';
    return String(m).toUpperCase();
  }

  window.fetch = function(input, init){
    var url = urlOf(input);
    var method = methodOf(input, init);

    /* a write invalidates the cache before it is even sent, so nothing can
       read a cart that is about to change */
    if (/\/cart\/(add|change|update|clear)(\.js)?/.test(url)){
      writeSeq++; cached = null; inflight = null;
      lastWrite = Date.now();
      var w = orig.apply(this, arguments);
      var landed = function(){ writeSeq++; cached = null; inflight = null; };
      if (w && typeof w.then === 'function') w.then(landed, landed);
      return w;
    }

    if (method === 'GET' && /\/cart\.js(\?|$)/.test(url)){
      if (cached && (Date.now() - cachedAt) < TTL){
        /* clone every time: a Response body can only be read once, and the
           stored copy is never read itself */
        return Promise.resolve(cached.clone());
      }
      if (inflight) return inflight.then(function(r){ return r.clone(); });

      var seq = writeSeq;
      var p = orig.apply(this, arguments).then(function(r){
        if (r && r.ok && seq === writeSeq){ cached = r.clone(); cachedAt = Date.now(); }
        if (inflight === p) inflight = null;
        return r;
      }, function(e){
        if (inflight === p) inflight = null;
        throw e;
      });
      inflight = p;
      return p.then(function(r){ return r.clone(); });
    }

    return orig.apply(this, arguments);
  };

  /* ---------------- one drawer rebuild at a time ---------------- */

  function coalesce(){
    var real = window.pgDrawerRefresh;
    if (typeof real !== 'function' || real.pgFast) return;

    /* JOINING IS ONLY SAFE WHILE THE SNAPSHOT IS STILL FRESH.
       spRefreshDrawer rebuilds the drawer from a GET of the homepage, so what it
       renders is the cart as it stood WHEN THAT REQUEST WAS ISSUED. Joining an
       already-issued request therefore hands the second caller a snapshot taken
       before its own write, and because done() cleared `running` with nothing
       queued, no corrective rebuild ever followed. Reproduced against the real
       theme scripts: a shopper who adds from the product page and then taps the
       drawer upsell makes three cart writes but only two GETs go out, and seven
       seconds later the drawer still shows the pre-add cart. That is not a
       flicker -- the shopper's add looks as though it did not happen.

       The 700ms floor and the single-flight both stay; the wrapper just learns
       to notice. A join during `wait` costs nothing extra, because the request
       has not gone out yet and its snapshot will already contain that write. A
       join after it went out queues exactly one redo. It cannot loop: the redo's
       own snapshot postdates the write that triggered it. And resolve() still
       fires on the first landing, so a caller waiting on this -- pg-unlock's ADD
       button -- can never hang behind the redo.

       Marking at send time rather than landing time is deliberately
       conservative: a write sent before the GET but landing after it is exactly
       the race being closed.

       This covers only the callers that go through window.pgDrawerRefresh.
       nc-cartfix's own ncReopen() and pg-drawer's two internal calls rebuild
       outside the wrapper entirely and are unaffected either way. */
    var running = null, lastDone = 0, snapAt = 0;

    var wrapped = function(){
      if (running) return running;                 /* join the one in flight */
      var wait = Math.max(0, 700 - (Date.now() - lastDone));
      running = new Promise(function(resolve){
        setTimeout(function(){
          snapAt = Date.now();                     /* the moment GET / is issued */
          var done = function(){
            lastDone = Date.now();
            running = null;
            resolve();
            if (lastWrite > snapAt) wrapped();     /* snapshot predates a write */
          };
          try { Promise.resolve(real()).then(done, done); }
          catch (e){ done(); }
        }, wait);
      });
      return running;
    };
    wrapped.pgFast = 1;
    window.pgDrawerRefresh = wrapped;
  }

  coalesce();
  setInterval(coalesce, 800);
})();
